function getParameterCaseInsensitive (object, key) {
  //if the first argument is an object with keys and the second argument is a string with a value
  if (object && typeof object === 'object' && Object.keys(object).length && key && typeof key === 'string') {
    return object[Object.keys(object).find(k => k.toLowerCase() === key.toLowerCase())];
  }
  return null;
}

function getAmericanFundsBaseUrl(stagingFlag) {
  const hostname = window.location.hostname;
  switch (hostname) {
    // local
    case 'localhost':
      return 'http://localhost/capitalgroup/americanfunds';
      // dev and internal QA
    case 'capitalgroup-afis.dev.services.mdgapp.net':
    case 'capitalgroup-afis.qa.services.mdgapp.net':
    case 'afis.capitalgroup.markitqa.com':
      if (stagingFlag === 'UAT2') {
        return 'https://capitalgroup-a2.wsodqa.com/americanfunds';
      } else if (stagingFlag === 'UAT3') {
        return 'https://capitalgroup-a3.wsodqa.com/americanfunds';
      } else if (stagingFlag === 'UAT4') {
        return 'https://capitalgroup-a4.wsodqa.com/americanfunds';
      }
      return 'https://capitalgroup.wsodqa.com/americanfunds';
      // QA
    case 'www.stg.capitalgroup.com':
      return 'https://www.stg.capitalgroup.com';
      // internal prod
    case 'capitalgroup-afis.ctc.services.mdgapp.net':
      return 'capitalgroup.ctc.wallst.com/americanfunds';
    case 'capitalgroup-afis.ptc.services.mdgapp.net':
      return 'capitalgroup.ptc.wallst.com/americanfunds';
    case 'afis.capitalgroup.markitondemand.com':
      return 'capitalgroup.wallst.com/americanfunds';
      // prod
    default:
      return 'https://www.capitalgroup.com';
  }
}

const convertToDateObject = d => {
  // Converts the date in d to a date-object. The input can be:
  //   a date object: returned without modification
  //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
  //   a number     : Interpreted as number of milliseconds
  //                  since 1 Jan 1970 (a timestamp)
  //   a string     : Any format supported by the javascript engine, like
  //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
  //  an object     : Interpreted as an object with year, month and date
  //                  attributes.  **NOTE** month is 0-11.
  const validInput = d
		&& (
		  (
		    d.constructor === Date
		  )
			|| (
			  d.constructor === Array
				&& d.length === 3
				&& d[0] > -1
				&& d[1] >= 0
				&& d[1] <= 11
			)
			|| (
			  typeof d === 'number'
				&& d > -1
			)
			|| (
			  typeof d === 'string'
			)
			|| (
			  typeof d === 'object'
				&& Object.keys(d).length === 3
				&& Object.keys(d).includes('date')
				&& Object.keys(d).includes('month')
				&& Object.keys(d).includes('year')
			)
		);

  /*eslint-disable no-nested-ternary*/
  return validInput && (
    d.constructor === Date ? d :
      d.constructor === Array ? new Date(d[0], d[1], d[2]) :
        d.constructor === Number ? new Date(d) :
          d.constructor === String ? new Date(d) :
            typeof d === 'object' ? new Date(d.year, d.month, d.date) :
              null
  )
	|| null;
};

const compareTwoDates = (a, b) => {
  // Compare two dates (could be of any type supported by the convert
  // function above) and returns:
  //  -1 : if a < b
  //   0 : if a = b
  //   1 : if a > b
  // NaN : if a or b is an illegal date
  // NOTE: The code inside isFinite does an assignment (=).
  let dateA;
  let dateB;
  return (
    isFinite(dateA = convertToDateObject(a).valueOf()) &&
			isFinite(dateB = convertToDateObject(b).valueOf()) ?
      (dateA > dateB) - (dateA < dateB) :
      NaN);
};

const shiftDate = (oldDate, offset, offsetType) => {
  const year = parseInt(oldDate.getFullYear(), 10);
  const month = parseInt(oldDate.getMonth(), 10);
  const date = parseInt(oldDate.getDate(), 10);
  const hour = parseInt(oldDate.getHours(), 10);
  let newDate;
  switch (offsetType) {
    case 'Y':
    case 'y': {
      newDate = new Date(year + offset, month, date, hour);
      break;
    }
    case 'M':
    case 'm': {
      const a = month + offset;
      const monthsInAYear = 12;
      const updatedMonth = ((a % monthsInAYear) + monthsInAYear) % monthsInAYear;
      const updatedYear = year + Math.floor(a / monthsInAYear);
      newDate = new Date(updatedYear, updatedMonth, date, hour);
      break;
    }
    case 'D':
    case 'd': {
      const o = oldDate.getTime();
      const n = o + offset * 24 * 3600 * 1000;
      newDate = new Date(n);
      break;
    }
    case 'H':
    case 'h': {
      const o = oldDate.getTime();
      const n = o + offset * 3600 * 1000;
      newDate = new Date(n);
      break;
    }
    default:
      newDate = new Date(year + offset, month, date, hour);
  }
  return newDate;
};

/**
 * Gets the most recent date of the two, or uses the second if the first is unavailable.
 * Dates should be in yyyy-mm-dd format
 * @param {*} firstDate
 * @param {*} secondDate
 */
const getMostRecentDate = (firstDate, secondDate) => {
  let date = firstDate;
  if (!firstDate) {
    date = secondDate;
  } else if (firstDate !== secondDate) {
    const firstDateConverted = new Date(firstDate);
    const secondDateConverted = new Date(secondDate);
    if (firstDateConverted < secondDateConverted) {
      date = secondDate;
    }
  }
  return date;
};

/**
 * Summary: Returns a two-digit number string for a one or two digit number by prepending 0 if necessary
 * Default: if number is undefined it will return 'undefined'
 * Use: Can be used to convert a one-digit month or day value to a two-digit representation
 * Params:
 * number: A one or two digit number.  Passing in a three digit number will only return a string representation of the number.
 */
const getTwoDigitNumberString = number => {
  return number < 10 ? `0${number}` : `${number}`;
};

/**
 * Summary: Returns true if fund is older than 10 years based on inception Date
 * Default: returns true by default if inception date is null
 * Use: V&R charts need to be suppressed when the fund is less than 10 years older
 * Params:
 * inceptionDate: string of format '2019-07-01'
 */
 
 
const olderThan10Years = inceptionDate => {
  let older = true;
  if (inceptionDate) {
    const today = new Date();
    const inceptionString = inceptionDate.replace(/-/g, '');
    const currentMonth = getTwoDigitNumberString(today.getMonth() + 1);
    const currentDay = getTwoDigitNumberString(today.getDate());
    const currentString = `${today.getFullYear()}${currentMonth}${currentDay}`;

    const age = currentString - inceptionString;
    if (age < 100000) {
      older = false;
    }
  }
  return older;
};

const isNotNullOrUndefined = val => {
  return !(val === undefined || val === null);
};

const isMarkitEnvironment = () => {
  const windowLocation = window.location.hostname;
  return (
    windowLocation.indexOf('localhost') !== -1 ||
			windowLocation.indexOf('markitqa') !== -1 ||
			windowLocation.indexOf('markitondemand') !== -1 ||
			windowLocation.indexOf('mdgapp') !== -1
  );
};

const isValidValue = val => {
  return isNotNullOrUndefined(val)
		&& val !== '-32768'
		&& val !== -32768
		&& val !== '--';
};

export {
  compareTwoDates,
  isNotNullOrUndefined,
  convertToDateObject,
  getAmericanFundsBaseUrl,
  getParameterCaseInsensitive,
  shiftDate,
  isMarkitEnvironment,
  getMostRecentDate,
  isValidValue,
  olderThan10Years,
  getTwoDigitNumberString
};
